const formsRoutes = [
  {
    path: "/forms/category/:category",
    name: "FormsCategoryDocuments",
    component: () => import(/* webpackChunkName: "auth" */ "./pages/forms-category-document.vue"),
  },
  {
    path: "/forms/category",
    name: "FormsCategory",
    component: () => import(/* webpackChunkName: "auth" */ "./pages/forms-category.vue"),
  },
  {
    path: "/forms",
    name: "Forms",
    component: () => import(/* webpackChunkName: "auth" */ "./pages/forms.vue"),
    meta: {
      showForAllLoggedUsers: true,
      showForGuestUsers: true,
    },
  },
];

export default formsRoutes;
